module.exports = __webpack_public_path__ + "img/foreground-circuit-02.fa2260b8.svg";